// utils/dateOnly.js
//
// Calendar dates (joining date, deployment date, ...) are business dates in
// IST, the organisation's zone. The API sends them as 'YYYY-MM-DD'
// (backend utils/dbDateOnly.js#toApiDateOnly). An older response could
// still carry a serialized mysql2 Date -- e.g. '2026-09-24T18:30:00.000Z'
// for a stored 2026-09-25 on the IST server -- whose first 10 characters
// are the PREVIOUS day. Such a timestamp is read as its IST calendar day
// instead of being sliced, so the date never shifts in either form.

const IST_DAY = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

function isRealDate(y, m, d) {
  const check = new Date(Date.UTC(y, m - 1, d));
  return check.getUTCFullYear() === y && check.getUTCMonth() === m - 1 && check.getUTCDate() === d;
}

/** 'YYYY-MM-DD' for a date-only value or a timestamp; null when empty/invalid. */
export function toDateOnlyString(value) {
  if (value === null || value === undefined || value === "") return null;
  const str = String(value).trim();
  const m = DATE_ONLY_RE.exec(str);
  if (m) return isRealDate(Number(m[1]), Number(m[2]), Number(m[3])) ? str : null;
  if (!/^\d{4}-\d{2}-\d{2}T/.test(str)) return null;
  const d = new Date(str);
  if (Number.isNaN(d.getTime())) return null;
  return IST_DAY.format(d);
}

/** { y, mo, d } for date math, or null. */
export function dateOnlyParts(value) {
  const str = toDateOnlyString(value);
  if (!str) return null;
  const [y, mo, d] = str.split("-").map(Number);
  return { y, mo, d };
}

/** "25 Sept 2026" style label (en-GB), or fallback when empty/invalid. */
export function formatDateOnly(value, fallback = "-") {
  const p = dateOnlyParts(value);
  if (!p) return fallback;
  return new Date(Date.UTC(p.y, p.mo - 1, p.d)).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}
